import React from 'react';

import bunny from '~/images/free-trial-bunny.svg';
import PartialCTA from '../partials/cta';

interface FreeTrialLeftProps {
  block: {
    title: string;
    text: string;
    cta_field: {
      cta_link: string;
      cta_text: string;
    };
  };
}

export default function FreeTrialLeft({ block }: FreeTrialLeftProps) {
  return (
    <div className='freetrial-wr'>
      <img
        src={bunny}
        alt={block.title}
        title={block.title}
        className='parallax'
        loading='lazy'
      />
      <div className='row'>
        <div className='col-xl-5 col-lg-6'>
          <div className='content-wr'>
            {block.title && (
              <h2 dangerouslySetInnerHTML={{ __html: block.title }}></h2>
            )}
            {block.text && (
              <p dangerouslySetInnerHTML={{ __html: block.text }}></p>
            )}
            {block.cta_field && <PartialCTA data={block.cta_field} />}
          </div>
        </div>
      </div>
    </div>
  );
}
